export const roles = [
    { label: "Admin", value: "1" },
    { label: "Superviseur", value: "2" },
    { label: "Utilisateur", value: "3" },
  ];
  
  export const getRoleLabel = (value) => {
    const role = roles.find((r) => r.value === String(value));
    return role ? role.label : "Inconnu";
  };
  